import { render } from "./STDSCM04C04TearmsOfServiceModal.vue?vue&type=template&id=27ace849&scoped=true"
import script from "./STDSCM04C04TearmsOfServiceModal.vue?vue&type=script&lang=js"
export * from "./STDSCM04C04TearmsOfServiceModal.vue?vue&type=script&lang=js"

import "./STDSCM04C04TearmsOfServiceModal.vue?vue&type=style&index=0&id=27ace849&scoped=true&lang=css"

import exportComponent from "D:\\TDS\\40_製造(M)\\99_電帳法_USE\\Tatsuzin_filemanage\\vue\\tdsvue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27ace849"]])

export default __exports__